import * as expression from '../../../expression'
import type { Query } from '../../query'
import { Subquery } from '../../subquery'
import { Target } from '../../target'
import { Variable } from '../../variable'

/**
 * Returns an {@link expression.Expression} that produces an object containing attributes
 * of the query entity, if there is a query entity, and results of the subqueries,
 * if there are any
 */
// TODO: maybe base on nodes rather than raw query?
export function getDefaultSelection(query: Query): expression.Expression {
  const objectExpressions: expression.Expression<Record<string, unknown>>[] = []

  if (Target.DateRange.List.isList(query.target)) {
    objectExpressions.push({
      [expression.fn.Key.CreateObject]: {
        period: {
          [expression.fn.Key.GetVariable]: Variable.Name.Reserved.from(
            expression.fn.definitions.utils.CommonName.Period,
          ),
        },
      },
    })
  } else if (query.target) {
    objectExpressions.push({ [expression.fn.Key.GetRecord]: {} })
  }

  const subqueryAliases = Subquery.Name.declaredIn(query)
  if (subqueryAliases.length) {
    objectExpressions.push({
      [expression.fn.Key.CreateObject]: subqueryAliases.reduce<
        expression.fn.definitions.CreateObject[expression.fn.Key.CreateObject]
      >(
        (prev, alias) =>
          Object.assign(prev, {
            [alias]: {
              [expression.fn.Key.GetSubquery]: alias,
            } satisfies expression.fn.definitions.GetSubquery,
          }),
        {},
      ),
    })
  }
  switch (objectExpressions.length) {
    case 0:
      return { [expression.fn.Key.CreateObject]: {} }
    case 1:
      return objectExpressions[0]
    default:
      return { [expression.fn.Key.Concatenate]: objectExpressions }
  }
}
